import e from "../managers/braze-instance.js";
import { keys as oo } from "../util/code-utils.js";
import r from "../../shared-lib/braze-shared-lib.js";
import { BRAZE_MUST_BE_INITIALIZED_ERROR as P } from "../common/constants.js";
export function wipeData() {
  if (null == e.l()) throw new Error(P);
  const o = e.l();
  o && o.clearData();
  const t = oo(r.zt);
  for (let o = 0; o < t.length; o++) {
    const n = t[o],
      s = r.zt[n];
    new r.xt(s, r.j).clearData();
  }
  if (e.rr()) for (const o of e.gr()) o.clearData(!0);
}
